import { FormEvent, useState } from 'react';
import Button from '../../components/button';
import ButtonGroup from '../../components/buttonGroup';
import Heading from '../../components/heading';
import Input from '../../components/input';
import Message, { IMessage } from '../../components/message';
import { useGlobalState } from '../globalState/GlobalStateProvider';
import styles from './identifier.module.css';

async function fetchIdentifierAccounts(email: string) {
  const body = { email };

  const response = await fetch(
    `${process.env.REACT_APP_USER_API}/sso/accounts`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
  );

  const data = response?.json() || undefined;

  return data;
}

const Identifier: React.FC = () => {
  const { state, setState } = useGlobalState();

  const [ready, setReady] = useState(true);
  const [messages, setMessages] = useState<IMessage | null>(null);

  const [email, setEmail] = useState(state.email);
  const [password, setPassword] = useState(state.passwordHint);

  async function handleClick(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();

    if (email && ready) {
      setReady(false);
      try {
        const data = await fetchIdentifierAccounts(email);

        if (
          data.connections &&
          data.connections[0] &&
          data.connections[0].type &&
          data.connections[0].connection
        ) {
          setState({
            ...state,
            page: data.connections[0].type,
            email,
            passwordHint: password,
            connection: data.connections[0].connection,
          });
        } else if (data.corporateEmail) {
          setMessages({
            type: 'error',
            text: "Scholenaccounts worden door de ICC'er van je school beheerd. Neem contact met hen op voor inloggegevens.",
          });

          setReady(true);
        } else if (data.connections && !data.connections.length) {
          setState({
            ...state,
            page: 'registration',
            email,
          });
        } else {
          setMessages({
            type: 'error',
            text: 'Er gaat iets fout bij het zoeken naar je account. Probeer het later nog een keer.',
          });

          setReady(true);
        }
      } catch (e) {
        setMessages({
          type: 'error',
          text: 'Er gaat iets fout bij het zoeken naar je account. Probeer het later nog een keer.',
        });

        setReady(true);
      }
    }
  }

  return (
    <div id="identifier">
      <Heading title="Inloggen of CKC-account aanmaken">
        <p>
          Vul je e-mailadres in, dan controleren we of je al een CKC-account
          hebt. Zo niet, dan kan je er één aanmaken.
        </p>
      </Heading>
      <Message message={messages} />
      <form onSubmit={handleClick}>
        <Input
          type="email"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          label="E-mail"
          name="email"
          placeholder="mijn@email.nl"
          autoComplete="username"
          autoFocus
        />
        <input
          type="password"
          name="password"
          autoComplete="current-password"
          tabIndex={-1}
          aria-hidden="true"
          className={styles.password}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <ButtonGroup>
          <Button type="submit" formReady={ready}>
            Volgende
          </Button>
        </ButtonGroup>
      </form>
    </div>
  );
};

export default Identifier;
